export enum DiffState {
  enter = 'enter',
  update = 'update',
  exit = 'exit',
  unChange = 'unChange'
}
